import { Box } from '@mui/material';
import React, { ReactElement } from 'react';
import { Radio } from '../Radio';

export enum FollowingOption {
  AllUpcomingEvents = 'All Upcoming Events',
  FollowedOrganizations = 'Followed Organizations',
}

export interface EventFollowingSelectorProps {
  selection: FollowingOption;
  onChange: (selection: FollowingOption) => void;
}

export const EventFollowingSelector = ({
  selection,
  onChange,
}: EventFollowingSelectorProps): ReactElement => {
  return (
    <Box mt={16} mb={32}>
      {Object.values(FollowingOption).map((option, i) => (
        <Box key={i} mb={16}>
          <Radio label={option} selectedValue={selection} onChange={onChange} />
        </Box>
      ))}
    </Box>
  );
};
